import React from "react";
import {connect} from 'react-redux';

class AuthorizationComponent extends React.Component {

    getAuth = () => {
        return this.props.auth
    }

    isPermission = (permissions, roles) => {
        let autorizado = false;

        roles.forEach(e => {
            if (permissions.includes(e)) autorizado = true;
        });
        return autorizado;
    }

    render() {
        const roles = this.getAuth().roles;
        return (this.isPermission(this.props.roles, roles) || this.props.roles === undefined)
            ? <div> {this.props.children} </div> : null;
    }
}

function mapStateToProps(state) {
    return {auth: state.auth};
}

export default connect(mapStateToProps)(AuthorizationComponent)



// WEBPACK FOOTER //
// ./src/auth/components/AuthorizationComponent.js